import { render, staticRenderFns } from "./TrainReversals.vue?vue&type=template&id=61d3545c"
import script from "./TrainReversals.vue?vue&type=script&lang=js"
export * from "./TrainReversals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports